// extracted by mini-css-extract-plugin
export default {"header":"TNEDashboardHeader_header__m8KoY","title":"TNEDashboardHeader_title__Xu6mC"};